/**
 * D-057 share-link referral code read from the `ref` search param.
 *
 * Expo Router hands a repeated query parameter (`?ref=A&ref=A`, e.g. added again
 * by a link wrapper) over as an array; treating that as "no referral" silently
 * dropped the indication and hid the code field. The LAST non-empty value wins,
 * the same "last indication wins" rule D-057 applies to signup attribution. The
 * code is then shown in the editable code field and validated by the server like
 * any other, so the visitor sees it and can correct it (ALL-13 review 2).
 */
export function shareLinkReferralCode(ref: string | string[] | undefined): string {
  const values = (Array.isArray(ref) ? ref : [ref])
    .map(value => (typeof value === 'string' ? value.trim().toUpperCase() : ''))
    .filter(Boolean);
  return values.length ? values[values.length - 1] : '';
}

/**
 * Capture time of a referral kept on the device, forwarded as `ref_at` by the
 * persona choice (D-057). Only a parseable ISO time is passed on; the server
 * applies the Admin link validity to it. A live link carries no `ref_at`.
 */
export function shareLinkCapturedAt(refAt: string | string[] | undefined): string | undefined {
  const value = Array.isArray(refAt) ? refAt[refAt.length - 1] : refAt;
  if (typeof value !== 'string' || !Number.isFinite(Date.parse(value))) return undefined;
  return new Date(value).toISOString();
}
